import { IIconProps } from '@cian/ui-kit/prev/icons/internal';
import * as React from 'react';

import MY_HOME_ICON from './assets/Key.svg';

export const MyHomeIcon: React.FC<IIconProps> = () => {
  return <img src={MY_HOME_ICON} width={16} height={16} alt="" />;
};
